import { Button, Dropdown } from '@/components';
import { Role } from '@/modules/Users/domain/role';
import { RoleEntity } from '@/modules/Users/types/role';
import { getDropdownArray } from '@/utils/get-dropdown-array.util';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { CrossDelete } from '../../../../../../components/Icons';

export type UsersRoleDropdownProps = {
  items: Array<{ id: number; value: string; role?: number }>;
  roles?: Role[];
  roleEntity?: RoleEntity;
  deleteUser: (index: number) => void;
  selectRole: (roleId: number, userId: number) => void;
};

export const UsersRoleDropdown = ({
  items,
  roles,
  deleteUser,
  selectRole,
  roleEntity,
}: UsersRoleDropdownProps) => {
  const { t } = useTranslation();
  const roleDropdownOptions = useMemo(
    () =>
      getDropdownArray(
        roles?.map((r) => ({
          id: r.id,
          name: t(`roles.${r.name}`, { entity: roleEntity && t(roleEntity) }),
        })) ?? [],
      ),
    [roleEntity, roles, t],
  );

  return (
    <div
      className={twMerge(
        'divide-y',
        items.length > 0 && 'border-b-1 border-t-1',
      )}
    >
      {items.map((item, index) => (
        <div
          key={index}
          className="flex h-auto flex-row items-center justify-between p-2"
        >
          {item.value}
          <div className="flex w-1/2 items-center justify-end">
            {!!roles?.length && (
              <Dropdown
                className="h-10 w-full rounded-md bg-brightGray capitalize italic"
                placeholder={t('profile')}
                options={roleDropdownOptions}
                onSelect={(val) => selectRole(val?.value, item.id)}
                value={item.role}
              />
            )}
            <Button
              variant="text"
              onClick={() => deleteUser(index)}
              className="pl-3"
            >
              <CrossDelete className="text-[#191B23]" />
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};
